module.exports = __webpack_public_path__ + "img/point_title2_sp.1936a683.svg";